import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { getAnalytics, logEvent, setUserId, setUserProperties } from "firebase/analytics";
import InfosProfil from '../data/InfosProfil';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIRE_BASE_API_KEY,
    authDomain: process.env.REACT_APP_FIRE_BASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIRE_BASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIRE_BASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIRE_BASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIRE_BASE_APP_ID,
    measurementId: process.env.REACT_APP_FIRE_BASE_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);

// ── Messaging lazy — instancié uniquement si le navigateur le supporte ────────
let messagingInstance: ReturnType<typeof getMessaging> | null = null;

async function getMessagingInstance() {
    if (messagingInstance) return messagingInstance;
    const supported = await isSupported();
    if (!supported) return null;
    messagingInstance = getMessaging(firebaseApp);
    return messagingInstance;
}

// ── fetchToken ────────────────────────────────────────────────────────────────
export const fetchToken = async (callBack: Function) => {
    const messaging = await getMessagingInstance();
    if (!messaging) {
        callBack("Messaging not supported on this browser.", false);
        return;
    }

    getToken(messaging, { vapidKey: process.env.REACT_APP_FIRE_BASE_VAPID_KEY })
        .then((currentToken) => {
            if (currentToken) {
                console.log('current token for client: ', currentToken);
                callBack(currentToken, true);
            } else {
                console.log('No registration token available.');
                callBack("No registration token available.", false);
            }
        })
        .catch((err) => {
            callBack("An error occurred while retrieving token.", false);
            console.log('An error occurred while retrieving token. ', err);
        });
};

// ── onMessageListener ─────────────────────────────────────────────────────────
export const onMessageListener = () =>
    new Promise(async (resolve, reject) => {
        const messaging = await getMessagingInstance();
        if (!messaging) {
            reject(new Error('Messaging not supported on this browser.'));
            return;
        }
        onMessage(messaging, (payload) => resolve(payload));
    });

// ── Analytics ─────────────────────────────────────────────────────────────────
export const log = (
    eventName: string,
    eventParams: { [key: string]: string } | undefined
) => logEvent(analytics, eventName, eventParams);

export const defineUser = (infosProfil: InfosProfil) => {
    setUserId(analytics, String(infosProfil.id));
    setUserProperties(analytics, { ...infosProfil.infosSettings });
};